import React from 'react'
import { Navigate } from 'react-router-dom'
import { Typography } from 'antd'
import { useAuth } from '../../contexts/AuthContext'
import { hasPermission, isAdmin, isDealer, isDealerOrAbove, canManageDealers, canManageVehicles, canManageTeam, canManagePricing } from '../../utils/permissions'
import { PERMISSIONS } from '../../utils/permissions'

const RouteGuard = ({ 
  children, 
  permission, 
  requireAdmin = false, 
  requireDealer = false,
  requireDealerOrAbove = false, 
  requireDealerManagement = false, 
  requireVehicleManagement = false, 
  requireTeamManagement = false,
  requirePricingManagement = false 
}) => {
  const { userProfile, isAuthenticated } = useAuth()

  // Check if user is authenticated
  if (!isAuthenticated || !userProfile) {
    return <Navigate to="/login" replace />
  }

  // Check admin requirement
  if (requireAdmin && !isAdmin(userProfile)) {
    return <Navigate to="/dashboard" replace />
  }

  // Check dealer only requirement (dealers only, not admins)
  if (requireDealer && !isDealer(userProfile)) {
    return <Navigate to="/dashboard" replace />
  }

  // Check dealer or above requirement
  if (requireDealerOrAbove && !isDealerOrAbove(userProfile)) {
    return <Navigate to="/dashboard" replace />
  }

  // Check dealer management requirement
  if (requireDealerManagement && !canManageDealers(userProfile)) {
    return <Navigate to="/dashboard" replace />
  }

  // Check vehicle management requirement
  if (requireVehicleManagement && !canManageVehicles(userProfile)) {
    return <Navigate to="/dashboard" replace />
  }

  // Check team management requirement
  if (requireTeamManagement && !canManageTeam(userProfile)) {
    return <Navigate to="/dashboard" replace />
  }

  // Check pricing management requirement
  if (requirePricingManagement && !canManagePricing(userProfile)) {
    return <Navigate to="/dashboard" replace />
  }

  // Check specific permission
  if (permission && !hasPermission(userProfile, permission)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default RouteGuard
